import Box from "@mui/material/Box";

export default function Contact_Video({ type }) {
  return (
    <Box
      component="video"
      autoPlay
      loop
      muted
      playsInline
      controls={false}
      src="/uae Banner.mp4"
      sx={{
        width:
          type === "why-contact"
            ? { xs: "100%", md: "580px" }
            : { xs: "100%", sm: "400px", md: "580px" },
        height:
          type === "why-contact"
            ? {
                xs: "350px",
                sm:"400px",
                md: "470px",
              }
            : { xs: "100%", sm: "350px", md: "470px" },
        objectFit: "cover",
        borderRadius: "16px",
        overflow: "hidden",
      }}
    />
  );
}
